<div class="mapa-page">
  <app-mapa-principal
    [sirenas]="sirenas"
    [clientes]="clientes"
    [mostrarSirenas]="mostrarSirenas"
    [mostrarZonas]="mostrarZonas"
    [filtroClientes]="filtroClientes"
    [filtroOnline]="filtroOnline"
    [verActualizaciones]="verActualizaciones"
    [center]="center"
    [customPosition]="customPosition"
    (sirenaClick)="onSirenaClick($event)"
  />

  <div class="flotante-pos">
    <app-flotante
      [sirenas]="sirenas.length"
      [loading]="loading()"
      (clientesChange)="clientesChange($event)"
      (estadoChange)="estadoChange($event)"
      (mostrarClientesChange)="mostrarClientesChange($event)"
      (mostrarSirenasChange)="mostrarSirenasChange($event)"
      (geocode)="geocode($event)"
    />
  </div>

  @if (sirenaSeleccionada) {
    <div class="isla-pos">
      <app-isla [sirena]="sirenaSeleccionada!" (cerrarChange)="cerrarIsla()" />
    </div>
  }
</div>
